import { Injectable } from '@angular/core';
import { forEach, split, trim } from 'lodash';

@Injectable()
export class NetworkSettingsService {
  constructor() {}

  /*
    Breaks given input string into individual tokens for further processing.
    Separators recognized: whitespaces (\s), comma, semicolon.
    NOTE: those tokens are assumed to be IP addresses - but no validation is done in this method!
  */
  parseDns(input) {
    const testInput = split(input, /[\s,;]/);
    const ipOnly = [];
    forEach(testInput, value => {
      const trimmed = trim(value);
      if (trimmed.length > 0) {
        ipOnly.push(trimmed);
      }
    });
    return ipOnly;
  }

  /**
   * Walks over given array of tokens and checks if each token conforms to a DNS name which is a pretty open string.
   * If at least one token is not conforming, returns false.
   */
  validateDns(tokens) {
    let isValid = true;
    forEach(tokens, ip => {
      if (!ip || ip.length <= 0) {
        isValid = false;
      }
    });
    return isValid;
  }
}
